<lib-header />
<main class="main-content">
  <router-outlet />
</main>
<lib-footer />
